import { useContext, useEffect } from "react";
import { GeneralCard } from "../../../../components/Cards/GeneralCard";
import GeneralTypeSeriesForm from "./GeneralTypeSeriesForm";
import AircraftList from "./AircraftList";
import { use } from "react";
import { TypeSeriesConfigurationContext } from "../../contexts/TypeSeriesConfigurationContext";

const AircraftConfigurationGrid = ({ aircraft, open, setOpen }) => {
  const { isAircraftSectionDraft, saveDraft, updateSection } = useContext(
    TypeSeriesConfigurationContext
  );
  const handleCloseForm = () => {
    setOpen(false);
  };
  const isEnabled = (section) => isAircraftSectionDraft(aircraft.id, section);
  const generalFieldHandler = (formValue) => {
    updateSection(formValue, aircraft.id, "general");
    // let { name, value } = formValue;
    // updateRow(part.id, rowUpdater[name]?.(value) ?? { [name]: value });
  };

  return (
    open && (
    <div className="aircraft-configuration-grid-component">
      <GeneralCard>
        <GeneralTypeSeriesForm
          onChange={generalFieldHandler}
          disabled={!isEnabled("general")}
          setOpen={handleCloseForm}
          open={open}
          aircraft={aircraft}
        />
      </GeneralCard>
    </div>)
  );
};

export default AircraftConfigurationGrid;
